import * as ChakraIcons from '@chakra-ui/icons'

export default ChakraIcons
